import { mapGetters } from 'vuex';
import { flowTypes } from '@/common/service/page-config';

export default {
  computed: {
    ...mapGetters(['boughtPlans', 'getSelectedPlans']),
    isEditFlow() {
      return this.$context.flow === flowTypes.edit && this.$context.is.editPage;
    },
    currentBoughtPlan() {
      const matchedPlan = this.boughtPlans.find(({ type }) => type === this.planType);
      if (matchedPlan) {
        return {
          type: this.planType,
          quantity: matchedPlan?.cartInfo?.selected_number,
          prices: matchedPlan.prices,
          amount: matchedPlan.amount,
          ratePlans: matchedPlan.ratePlans
        };
      } else {
        return null;
      }
    },
    currentSelectedQuantity() {
      const plan = this.getSelectedPlans.find(({ type }) => type === this.planType);
      return plan?.cartInfo?.selected_number ?? 0;
    },
    nonStandardPriceDisableDecreaseTipForTieredPlan() {
      const isShowCustomPriceDisableTooltip = (() => {
        const { prices, amount } = this.currentBoughtPlan;
        const tier1Price = prices[0];
        if (this.isEditFlow) {
          const isStandardPrice = amount === tier1Price.price
          if (isStandardPrice) {
            return false
          } else {
            return this.currentSelectedQuantity <= this.currentBoughtPlan?.quantity
          }
        } else {
          return false;
        }
      })();
      return isShowCustomPriceDisableTooltip ? this.$t('billing.planform.meeting_license_custom_pricing') : null
    },
  },
};
